import React, {useEffect, useState} from "react";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";
import { useLocation } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";
import configVars from "../config";
import ReactGA from "react-ga4";
import { LiveChatWidget } from "@livechat/widget-react";

const Routes = () => {

    const location = useLocation();
    const [isPrivate, setIsPrivate] = useState(false);
    const [loading, setLoading] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies( [ "sustainyou_user_jwt" ] );

    ReactGA.initialize("G-MNB59HT6MQ");

    useEffect(() => {

      if ( window.location.pathname === '/wp-content/themes/sustainchangeprod/' || window.location.pathname === '/wp-content/themes/sustainchangeprod' ) {
        window.location.href = '/';
      }

        if ( ! cookies.sustainyou_user_jwt ) return;

        const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);

        const timeNow = Math.floor(Date.now() / 1000);

        if ( jwtDecoded.exp > timeNow ) {
            setIsPrivate(true);
        } else {

            setLoading(true);

            (async () => {

                try {
                    const response = await fetch(
                      `${configVars.apiUrl}simple-jwt-login/v1/auth/refresh/`,
                      {
                        method: "POST",
                        headers: {
                          Authorization: `Basic ${configVars.auth}`,
                        },
                        body: JSON.stringify({
                          JWT: cookies.sustainyou_user_jwt,
                        }),
                      }
                    );
                    const authResponse = await response.json();
              
                    if (authResponse) {

                      if ( authResponse.success === true ) {
                        
                        setCookie("sustainyou_user_jwt", authResponse?.data?.jwt, { path: "/" });

                        setIsPrivate(true);

                      } else {

                        setIsPrivate(false);
                        removeCookie("sustainyou_user_jwt", { path: "/" });
                        
                        localStorage.clear();
                        window.location.href = "/login/?logout=true";

                      }
                      
                    }
                } catch (error) {
                    return error;
                }

                setLoading(false);

            })()

        }

        if ( window.location.origin === 'https://app.sustainchange.se' ) {
          ReactGA.send({ hitType: "pageview", page: window.location.pathname });
        }
        
    }, [location, isPrivate, cookies, setCookie, removeCookie]);

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);

    return (

        <>
            { isPrivate &&
                <PrivateRoutes />
            }

            { (!isPrivate && !loading) &&
                <PublicRoutes />
            }

            {!loading && window.location.origin === 'https://app.sustainchange.se' &&
              <LiveChatWidget license="15157764" visibility="minimized" />
            }

            { loading &&
              <div className="d-flex justify-content-center mt-6">
                <div className="spinner-border text-primary" role="status" >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            }
        </>
        
    )
}

export default Routes;